const PENDING_OAUTH_CAMPAIGN_KEY = 'pending_oauth_campaign';

export const storePendingOAuthCampaign = (campaign: string): void => {
  localStorage.setItem(PENDING_OAUTH_CAMPAIGN_KEY, campaign);
};

export const getPendingOAuthCampaign = (): string | null =>
  localStorage.getItem(PENDING_OAUTH_CAMPAIGN_KEY);

export const clearPendingOAuthCampaign = (): void => {
  localStorage.removeItem(PENDING_OAUTH_CAMPAIGN_KEY);
};
